import type { Demand } from '../types/demand'

/**
 * Whether a talent can apply now — the client's copy of the server's
 * `sql_posted()` (models/demand.py). Since 2026-10-16 the deadline closes
 * nothing: applications stay open until council or the caretaker close them,
 * which sets `applications_closed_at`.
 */
export function applicationsOpen(d: Pick<Demand, 'stage' | 'applications_closed_at'>): boolean {
  return (d.stage === 'open_to_application' || d.stage === 'resourcing') && !d.applications_closed_at
}

/** "Apply by Nov 15" while the deadline is ahead; null when there is none or it passed. */
export function applyBy(iso: string | null | undefined, now = Date.now()): string | null {
  if (!iso) return null
  const t = Date.parse(iso)
  if (Number.isNaN(t) || t <= now) return null
  return `Apply by ${new Date(t).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`
}
